// extracted by mini-css-extract-plugin
export default {"lockedBanner":"qshs2w"};